import React from 'react';
import SimpleNewsletterCard from './SimpleNewsletterCard';
import { useTranslations } from '../../localization/useTranslations';
import { RegularNewslettersSectionProps } from '../types/NewsletterPage';

const RegularNewslettersSection: React.FC<RegularNewslettersSectionProps> = ({
  newsletters,
  onNewsletterChange,
  checkIsSubscribed,
}) => {
  const translations = useTranslations();

  return (
    <div className="page-newsletter__section--regular">
      <h4 className="page-newsletter__section-title">
        {translations?.newsletterPage?.regularNewslettersSectionTitle || 'Our newsletters'}
      </h4>

      {newsletters && (
        <div className="row">
          {newsletters.map((newsletter) => (
            <div className="col-lg-3 col-md-4 col-12" key={newsletter.code}>
              <SimpleNewsletterCard
                newsletter={newsletter}
                isSubscribed={checkIsSubscribed(newsletter)}
                onChange={onNewsletterChange}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default RegularNewslettersSection;
